import { Coordinate, DEFAULT_START_LOCATION } from "../types/coordinate";
import { useLanguageStore } from "../store/languageStore";
import { useNavigationStore } from "../store/navigationStore";
import { findNavPath } from "../utils/navigation";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentPosition } from "../utils/geolocation";
import { useAppStore } from "../store/appStore";

import sampleRouteHKIA1 from "src/api/route_hkia_t2l8_t1l5.json";
import sampleRouteHKIA2 from "src/api/route_hkia_t1l5_t2l6.json";
import sampleRouteHKIA3 from "src/api/route_hkia_t2l7_t1l7.json";
import sampleRouteAS from "src/api/route_as.json";
import sampleRouteWKS from "src/api/route_wks.json";
import sampleRouteWKS2 from "src/api/route_wks2.json";
import sampleRouteWKS3 from "src/api/route_wks3.json";
import sampleRouteEntranceToTea from "src/api/route_entrance_to_tea.json";
import sampleRouteEntranceToStudio1 from "src/api/route_entrance_to_studio1.json";
import sampleRouteAtriumToStarPlace from "src/api/route_atrium_to_star_place.json";
import sampleRouteTicketToGrandTheatre from "src/api/route_ticket_to_grand_theatre.json";
import { NavigationDataResponse } from "@/types/navigation";

export function useFindPath(redirectToNav: boolean = false) {
  // const conversationId = useNavigationStore((state) => state.conversationId);
  const currentNavMode = useNavigationStore((state) => state.currentMode);
  const setNavData = useNavigationStore((state) => state.setNavData);
  const setIsShowNavigationRestartButton = useNavigationStore(
    (state) => state.setIsShowNavigationRestartButton,
  );
  const setIsShowNavigationContinueButton = useNavigationStore(
    (state) => state.setIsShowNavigationContinueButton,
  );
  const setVenueNotSupported = useNavigationStore(
    (state) => state.setVenueNotSupported,
  );
  const setUserQuery = useNavigationStore((state) => state.setUserQuery);
  const setApiError = useNavigationStore((state) => state.setApiError);
  const appLanguage = useLanguageStore((state) => state.appLanguage);
  const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
  let navigate = useNavigate();
  const setLoading = useNavigationStore((state) => state.setLoading);
  const setInterrupt = useNavigationStore((state) => state.setInterrupt);
  const setNavFrom = useNavigationStore((state) => state.setNavFrom);

  const appendChatHistory = useNavigationStore(
    (state) => state.appendChatHistory,
  );

  const handleUserQuery = useCallback(
    async (
      userQuery: string,
      options?: {
        useCurrentLocation?: boolean;
        mode?: string;
        startVenueId?: string;
        startMapId?: string;
        startCoordinate?: string;
        startPoi?: string;
      },
    ) => {
      const { useCurrentLocation = false, mode = currentNavMode } =
        options || {};

      const user = useAppStore.getState().ensureUserId();
      const trace = useNavigationStore.getState().ensureTraceId();
      console.log("handleUserQuery traceId:", trace, "userId:", user);

      try {
        setLoading(true);
        setIsShowNavigationRestartButton(false);
        setIsShowNavigationContinueButton(false);
        // if (redirectToNav) {
        //   navigate("/loading");
        // }
        console.log("handleUserQuery: redirectToNav=", redirectToNav);
        console.log("useCurrentLocation=", useCurrentLocation);

        let coordinate: Coordinate;
        if (!useCurrentLocation) {
          coordinate = DEFAULT_START_LOCATION;
        } else {
          const locationResult = await getCurrentPosition();

          if (locationResult.success && locationResult.data) {
            coordinate = locationResult.data;
            console.log("Using current location:", coordinate);
          } else {
            coordinate = DEFAULT_START_LOCATION;
            console.log("Using fallback location:", coordinate);
          }
        }

        console.log("mode: ", mode);
        setUserQuery(userQuery);
        // setApiError("");
        // setVenueNotSupported(false);

        // if (
        //   userQuery == "Show me how to get from Ticket Office to Tea House Theatre in Xiqu Centre." ||
        //   userQuery == "告訴我如何從戲曲中心售票處前往茶館劇院。" ||
        //   userQuery == "告诉我如何从戏曲中心售票处前往茶馆剧院。"
        // )
        if (
          userQuery ==
            "Show me how to get from T2 L8 Departure Kerb to T1 AEL platform in Hong Kong International Airport." ||
          userQuery ==
            "告訴我如何從香港國際機場二號客運大樓8樓落客區前往一號客運大樓機場快綫月台。" ||
          userQuery ==
            "告诉我如何从香港国际机场二号客运大楼8楼落客区前往一号客运大楼机场快綫月台。"
        ) {
          await setNavData(sampleRouteHKIA1, voiceLanguage);
          setNavFrom(sampleRouteHKIA1.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from T1 AEL platform to T2 L6 Airport Express (To AsiaWorld-Expo) in Hong Kong International Airport." ||
          userQuery ==
            "告訴我如何從香港國際機場一號客運大樓機場快綫月台前往二號客運大樓機場快綫月台（往博覽館）。" ||
          userQuery ==
            "告诉我如何从香港国际机场一号客运大楼机场快綫月台前往二号客运大楼机场快綫月台（往博览馆）。"
        ) {
          await setNavData(sampleRouteHKIA2, voiceLanguage);
          setNavFrom(sampleRouteHKIA2.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from T2 L7 food court to  T1 L7 Hong Kong Disneyland in Hong Kong International Airport." ||
          userQuery ==
            "告訴我如何從香港國際機場二號客運大樓7樓美食廣場前往一號客運大樓香港迪士尼樂園。" ||
          userQuery ==
            "告诉我如何从香港国际机场二号客运大楼7楼美食广场前往一号客运大楼香港迪士尼乐园。"
        ) {
          await setNavData(sampleRouteHKIA3, voiceLanguage);
          setNavFrom(sampleRouteHKIA3.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Customer Service Center to Platform 5 South Island Line to South Horizons in Admiralty Station." ||
          userQuery ==
            "告訴我如何從金鐘站客服中心前往5號月台搭乘南港島線前往海怡半島。" ||
          userQuery ==
            "告诉我如何从金钟站客服中心前往5号月台搭乘南港岛线前往海怡半岛。"
        ) {
          await setNavData(sampleRouteAS, voiceLanguage);
          setNavFrom(sampleRouteAS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from L1 Exit (Element) to Self-service Taxi Ticket in West Kowloon Station." ||
          userQuery ==
            "告訴我如何從西九龍站 L1 出口(圓方)前往自助的士取號機。" ||
          userQuery == "告诉我如何从西九龙站 L1 出口(圆方)前往自助的士取号机。"
        ) {
          await setNavData(sampleRouteWKS, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Meeting Point 3 to MX in West Kowloon Station." ||
          userQuery == "告訴我如何從西九龍站集合處3 前往美心MX。" ||
          userQuery == "告诉我如何从西九龙站集合处3 前往美心MX。"
        ) {
          await setNavData(sampleRouteWKS2, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Information Counter to Self-service ticket purchase in West Kowloon Station." ||
          userQuery == "告訴我如何從西九龍站詢問處前往自助購票。" ||
          userQuery == "告诉我如何从西九龙站询问处前往自助购票。"
        ) {
          await setNavData(sampleRouteWKS3, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Main Entrance to Tea House Theatre in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心正門前往茶館劇院。" ||
          userQuery == "告诉我如何从戏曲中心正门前往茶馆剧院。"
        ) {
          await setNavData(sampleRouteEntranceToTea, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Main Entrance to Studio 1 in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心正門前往排演室1。" ||
          userQuery == "告诉我如何从戏曲中心正门前往排演室1。"
        ) {
          await setNavData(sampleRouteEntranceToStudio1, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Atrium to Star Place in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心中庭前往明星樓。" ||
          userQuery == "告诉我如何从戏曲中心中庭前往明星楼。"
        ) {
          await setNavData(sampleRouteAtriumToStarPlace, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (
          userQuery ==
            "Show me how to get from Ticket Office to Grand Theatre in Xiqu Centre." ||
          userQuery == "告訴我如何從戲曲中心售票處前往大劇院。" ||
          userQuery == "告诉我如何从戏曲中心售票处前往大剧院。"
        ) {
          await setNavData(sampleRouteTicketToGrandTheatre, voiceLanguage);
          setNavFrom(sampleRouteWKS.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else if (userQuery == "Navigation Custom Json") {
          const customJson = prompt("Enter navigation json:", "");
          if (customJson == null || customJson == "") {
            return;
          }
          const customNavData: NavigationDataResponse = JSON.parse(
            customJson,
          ) as NavigationDataResponse;
          await setNavData(customNavData, voiceLanguage);
          setNavFrom(customNavData.nav[0].startingPoi.name ?? "");
          // setLoading(false);
          setInterrupt(false);
          navigate("/navigation");
        } else {
          var pathOptions = {};

          if (
            options?.startVenueId !== "" &&
            options?.startMapId !== "" &&
            options?.startCoordinate !== "" &&
            options?.startPoi !== ""
          ) {
            pathOptions = {
              startVenueId: options?.startVenueId,
              startMapId: options?.startMapId,
              startCoordinate: options?.startCoordinate,
              startPoi: options?.startPoi,
            };
          }
          console.log("useFindPath pathOptions:", pathOptions);
          appendChatHistory({ from: "user", message: userQuery });
          const result = await findNavPath(
            appLanguage,
            userQuery,
            mode,
            user,
            // conversationId,
            trace,
            coordinate,
            pathOptions,
          );
          console.log("result", result);
          if (
            (result.success &&
              result.data &&
              result.data.type == "nav" &&
              result.data.nav.length > 0 &&
              result.data.nav[0].navigation != null) ||
            (result.data?.type == "sightline" && result.data.nav.length > 0)
          ) {
            if (result.data.type == "nav") {
              await setNavData(result.data, voiceLanguage);

              if (
                result.data.nav.length > 0 &&
                result.data.nav[0].navigation.length > 0
              ) {
                // extract first node message, and remove "Start at"
                if (result.data.nav[0]?.startingPoi) {
                  setNavFrom(result.data.nav[0]?.startingPoi?.name ?? "");
                } else {
                  setNavFrom(
                    result.data.nav[0]?.navigation[0]?.message?.replace(
                      "Start at",
                      "",
                    ) ?? "",
                  );
                }
              }
            }
            appendChatHistory({ from: "bot", message: result.data.message });
            // setLoading(false);
            setInterrupt(false);
            console.log("navigate to navigation: userQuery:", userQuery);
            console.log("result.data:", result.data);
            if (result.data.navLink) {
              appendChatHistory({
                from: "bot",
                message: `Here is the Live AI route: ${result.data.navLink}`,
              });
            }
            // if (redirectToNav && result.data.navLink) {
            //   // use navLink to prevent long chatbot answer in 3d navigation
            //   window.location.replace(result.data.navLink);
            //   // navigate("/navigation");
            // }
            navigate("/");
          } else if (
            result.success &&
            result.data &&
            (result.data.nav.length == 0 ||
              (result.data.nav.length > 0 &&
                result.data.nav[0].navigation == null))
          ) {
            appendChatHistory({ from: "bot", message: result.data.message });
            setApiError(result.data.message);
            // if (result.data.nav.length == 0) {
            //   setVenueNotSupported(true);
            // }
            navigate("/");
          } else if (!result.success) {
            const error = result.error ?? "An error has occurred";
            setApiError(error);
            appendChatHistory({ from: "bot", message: error });
            // setLoading(false);
            setInterrupt(false);
            navigate("/");
          } else {
            setVenueNotSupported(true);
            // setLoading(false);
            setInterrupt(false);
            navigate("/");
          }
        }
      } catch (e) {
        setVenueNotSupported(true);
        setInterrupt(false);
        navigate("/");
        console.error("Failed to find navigation path:", e);
      } finally {
        setLoading(false);
      }
    },
    [
      appLanguage,
      // conversationId,
      currentNavMode,
      navigate,
      setNavData,
      setVenueNotSupported,
      setApiError,
      setUserQuery,
    ],
  );

  return { handleUserQuery };
}
